import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { HeaderThemeContext } from "@/components/HeaderThemeContext";

export default function Layout() {
  const { pathname } = useLocation();
  const [variant, setVariant] = useState("overlay");

  useEffect(() => {
    window.scrollTo(0, 0);
    // Deliberately no setVariant here. Child effects run before parent effects
    // in React, so resetting on navigation would overwrite the "solid" a
    // light-topped page just requested, leaving cream text on a cream header.
    // useSolidHeader's cleanup handles the reset when such a page unmounts.
  }, [pathname]);

  return (
    <HeaderThemeContext.Provider value={{ variant, setVariant }}>
      <SmoothScroll />
      <Header />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
    </HeaderThemeContext.Provider>
  );
}
